import React, { Component } from 'react';
import Wrapper from './style';
import { Modal, Button } from 'antd';
import { returnDate } from '../../common/utils';
import {
	EXCHANGE_CARD_ICON_BLACK,
	SUCCESS_COLLATERAL_VIEDO
} from '../../config/media';

class SuccessCollateralized extends Component {
	render() {
		const { visible, onOk, onCancel, collateral } = this.props;
		const imgIndex = (collateral.id % 6) + 1;
		return (
			<Modal
				visible={visible}
				onOk={onOk}
				onCancel={onCancel}
				title={null}
				footer={null}
				bodyStyle={{ padding: 0 }}
			>
				<Wrapper>
					<div className="success-image">
						<video autoPlay loop>
							<source src={SUCCESS_COLLATERAL_VIEDO} type="video/mp4" />
							Your browser does not support the video tag.
						</video>
					</div>
					<div style={{ padding: '12px' }}>
						<div className="collateral-info">
							<div style={{ textAlign: 'center' }}>
								<img
									src={EXCHANGE_CARD_ICON_BLACK[imgIndex]}
									alt="logo"
								/>
							</div>
							<div>
								<p>
									<b>XHT Locked:</b> {collateral.amount}&nbsp;
								</p>
								<p>
									<b>Exchange Slot Number:</b> #{collateral.no}&nbsp;
								</p>
								<p>
									<b>Date:</b> {returnDate(collateral.updated_at)}
								</p>
							</div>
						</div>
						<div className="disclamar">
							So what's next? Since you've collateralized your exchange
							you will be entitled to any unsold XHT during the&nbsp;
							<a
								href="https://pro.hollaex.com/"
								title="wave auction"
								target="_blank"
								rel="noopener noreferrer"
							>
								Wave Auction.
							</a>
							&nbsp; You will also have access to all up dates for the
							HollaEx Kit and future credit line and HollaEx liquidity
							network in the future.&nbsp;
							<a
								href="https://forum.hollaex.com"
								title="forum"
								target="_blank"
								rel="noopener noreferrer"
							>
								Learn more
							</a>
							&nbsp; about exchange slot number. <br />
							<a
								href="https://forum.hollaex.com"
								title="forum"
								target="_blank"
								rel="noopener noreferrer"
							>
								Learn more
							</a>
							&nbsp; about the Wave Auction.
						</div>
						<Button block type="primary" onClick={onOk}>
							View Exchange Collateral Page
						</Button>
					</div>
				</Wrapper>
			</Modal>
		);
	}
}

export default SuccessCollateralized;
